module.exports = function (svg) {
  $(svg).find('g:empty').remove();
  $(svg).find('g').each(function () {
    this.innerHTML.trim() || $(this).remove();
  });

  return svg;
};
